'use strict';
const COPA_ENHANCED = {
  initProgressBar() {
    const bar = document.createElement('div');
    bar.className = 'copa-progress-bar';
    document.body.prepend(bar);
    window.addEventListener('scroll', () => {
      const pct = window.scrollY / (document.body.scrollHeight - window.innerHeight);
      bar.style.transform = `scaleX(${Math.min(pct, 1)})`;
    }, { passive: true });
  },
  initBackToTop() {
    const btn = document.createElement('button');
    btn.className = 'copa-back-top';
    btn.innerHTML = '↑';
    btn.setAttribute('aria-label', 'Back to top');
    document.body.appendChild(btn);
    btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    window.addEventListener('scroll', () => btn.classList.toggle('visible', window.scrollY > 400), { passive: true });
  },
  initBottomNav() {
    if (document.querySelector('.copa-bottom-nav')) return;
    const nav = document.createElement('nav');
    nav.className = 'copa-bottom-nav';
    nav.setAttribute('aria-label', 'Mobile navigation');
    const items = [
      { icon: '🏠', label: 'Home', href: '/' },
      { icon: '⚽', label: 'Tees', href: '/collections/tournament-tees' },
      { icon: '🛒', label: 'Cart', href: '/cart' },
      { icon: '🔍', label: 'Search', href: '/search' },
      { icon: '❤️', label: 'Wishlist', href: '/pages/wishlist' },
    ];
    nav.innerHTML = items.map(i => `<a href="${i.href}" class="copa-bottom-nav-item"><span class="copa-bottom-nav-icon">${i.icon}</span><span>${i.label}</span></a>`).join('');
    document.body.appendChild(nav);
  },
  toastsWrap: null,
  initToastsV2() {
    this.toastsWrap = document.createElement('div');
    this.toastsWrap.className = 'copa-toasts-wrap';
    document.body.appendChild(this.toastsWrap);
  },
  toastV2(title, msg = '', type = 'info', duration = 3500) {
    const icons = { info: '⚽', success: '✅', error: '❌', warning: '⚠️', cart: '🛒', wish: '❤️' };
    const el = document.createElement('div');
    el.className = `copa-toast-v2 ${type}`;
    el.innerHTML = `<div class="copa-toast-icon-wrap">${icons[type] || icons.info}</div><div class="copa-toast-body"><div class="copa-toast-title">${title}</div>${msg ? `<div class="copa-toast-msg">${msg}</div>` : ''}</div>`;
    el.addEventListener('click', () => this._dismissToast(el));
    this.toastsWrap.appendChild(el);
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('show')));
    setTimeout(() => this._dismissToast(el), duration);
  },
  _dismissToast(el) {
    el.classList.remove('show');
    el.addEventListener('transitionend', () => el.remove(), { once: true });
  },
  confetti(opts = {}) {
    const { x = window.innerWidth / 2, y = window.innerHeight / 2, count = 60, colors = ['#2563eb','#dc2626','#fbbf24','#00d4ff','#00ff88','#7c3aed','#ea580c','#fff'] } = opts;
    for (let i = 0; i < count; i++) {
      const el = document.createElement('div');
      el.className = 'copa-confetti-particle';
      const size = 6 + Math.random() * 8;
      const color = colors[Math.floor(Math.random() * colors.length)];
      const angle = (Math.random() * 360) * (Math.PI / 180);
      const velocity = 80 + Math.random() * 140;
      const duration = 1.2 + Math.random() * 1.4;
      el.style.cssText = `left:${x}px;top:${y}px;width:${size}px;height:${size}px;background:${color};border-radius:${Math.random()>0.5?'50%':'2px'};`;
      const vx = Math.cos(angle) * velocity;
      const vy = Math.sin(angle) * velocity;
      el.animate([
        { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
        { transform: `translate(${vx}px,${vy - 100}px) rotate(${180 + Math.random()*360}deg)`, opacity: 1, offset: 0.4 },
        { transform: `translate(${vx * 1.5}px,${vy + 400}px) rotate(${360 + Math.random()*360}deg)`, opacity: 0 }
      ], { duration: duration * 1000, delay: Math.random() * 300, easing: 'cubic-bezier(0.25,0.46,0.45,0.94)', fill: 'forwards' });
      document.body.appendChild(el);
      setTimeout(() => el.remove(), (duration + 0.5) * 1000);
    }
  },
  initParallax() {
    const els = document.querySelectorAll('[data-parallax]');
    if (!els.length) return;
    const onScroll = () => { els.forEach(el => { const rect = el.getBoundingClientRect(); const speed = parseFloat(el.dataset.parallax) || 0.3; const offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * speed; el.style.transform = `translateY(${offset}px)`; }); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  },
  initLazyImages() {
    const obs = new IntersectionObserver(entries => { entries.forEach(e => { if (e.isIntersecting) { const img = e.target; if (img.dataset.src) img.src = img.dataset.src; img.classList.add('loaded'); obs.unobserve(img); } }); }, { rootMargin: '200px' });
    document.querySelectorAll('img[loading="lazy"]').forEach(img => obs.observe(img));
  },
  _quickViewOverlay: null,
  initQuickView() {
    const overlay = document.createElement('div');
    overlay.className = 'copa-modal-overlay';
    overlay.id = 'copaQuickView';
    overlay.innerHTML = `<div class="copa-modal" role="dialog" aria-modal="true"><button class="copa-modal-close" id="copaQVClose" aria-label="Close">✕</button><div class="copa-modal-body"><div class="copa-modal-gallery"><div class="copa-modal-main-img"><span id="copaQVEmoji">⚽</span></div></div><div class="copa-modal-info"><h2 class="copa-modal-product-name" id="copaQVTitle"></h2><div class="copa-review-stars" style="color:#ffd700;margin:0.5rem 0;">★★★★★ <span style="font-size:0.8rem;color:#64748b">4.8 · 200+ reviews</span></div><div class="copa-modal-price-wrap"><span class="copa-modal-price" id="copaQVPrice"></span></div><div><div class="copa-variant-label" style="font-size:0.72rem;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#64748b;margin-bottom:0.4rem;">SIZE</div><div class="copa-variant-options" id="copaQVVariants"></div></div><p class="copa-modal-desc" id="copaQVDesc"></p><button class="copa-modal-add" id="copaQVAdd">🛒 ADD TO CART — GET YOUR GEAR</button><div class="copa-modal-trust" style="display:flex;gap:1rem;font-size:0.72rem;color:#64748b;margin-top:0.5rem;"><span>🚚 Free shipping $50+</span><span>🔒 Secure checkout</span><span>↩️ 30-day returns</span></div></div></div></div>`;
    document.body.appendChild(overlay);
    this._quickViewOverlay = overlay;
    document.getElementById('copaQVClose').addEventListener('click', () => this.closeQuickView());
    overlay.addEventListener('click', e => { if (e.target === overlay) this.closeQuickView(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.closeQuickView(); });
    document.addEventListener('click', e => {
      const trigger = e.target.closest('[data-quick-view]');
      if (!trigger) return;
      e.preventDefault();
      const data = JSON.parse(trigger.dataset.quickView || '{}');
      this.openQuickView(data);
    });
  },
  openQuickView(product) {
    const ov = this._quickViewOverlay;
    document.getElementById('copaQVTitle').textContent = product.title || 'Product';
    document.getElementById('copaQVEmoji').textContent = product.emoji || '⚽';
    document.getElementById('copaQVPrice').textContent = product.price || '$0.00';
    document.getElementById('copaQVDesc').textContent = product.desc || 'Official World Cup 2026 fan merchandise.';
    const varWrap = document.getElementById('copaQVVariants');
    const variants = product.variants || ['S','M','L','XL','2XL'];
    varWrap.innerHTML = variants.map((v,i) => `<button class="copa-variant-btn ${i===0?'selected':''}">${v}</button>`).join('');
    varWrap.querySelectorAll('.copa-variant-btn').forEach(btn => { btn.addEventListener('click', () => { varWrap.querySelectorAll('.copa-variant-btn').forEach(b => b.classList.remove('selected')); btn.classList.add('selected'); }); });
    const addBtn = document.getElementById('copaQVAdd');
    addBtn.onclick = () => { const r = addBtn.getBoundingClientRect(); this.confetti({ x: r.left + r.width/2, y: r.top, count: 40 }); this.toastV2('Added to cart!', product.title, 'cart'); this.closeQuickView(); };
    ov.classList.add('open');
    document.body.style.overflow = 'hidden';
  },
  closeQuickView() { this._quickViewOverlay?.classList.remove('open'); document.body.style.overflow = ''; },
  flyToCart(fromEl) {
    const cartEl = document.querySelector('a[href="/cart"], .copa-icon-btn[aria-label*="Cart"]');
    if (!fromEl || !cartEl) return;
    const fromRect = fromEl.getBoundingClientRect();
    const toRect = cartEl.getBoundingClientRect();
    const particle = document.createElement('div');
    particle.textContent = '⚽';
    particle.style.cssText = `position:fixed;left:${fromRect.left + fromRect.width/2}px;top:${fromRect.top + fromRect.height/2}px;font-size:1.5rem;z-index:99999;pointer-events:none;`;
    document.body.appendChild(particle);
    const dx = toRect.left - fromRect.left + (toRect.width - fromRect.width)/2;
    const dy = toRect.top - fromRect.top + (toRect.height - fromRect.height)/2;
    particle.animate([{transform:'translate(0,0) scale(1)',opacity:1},{transform:`translate(${dx*0.4}px,${dy*0.4-80}px) scale(0.8)`,opacity:1,offset:0.4},{transform:`translate(${dx}px,${dy}px) scale(0.2)`,opacity:0}],{duration:700,easing:'cubic-bezier(0.25,0.46,0.45,0.94)',fill:'forwards'});
    setTimeout(() => { particle.remove(); cartEl.classList.add('cart-animate'); setTimeout(() => cartEl.classList.remove('cart-animate'), 600); }, 700);
  },
  initBundleTimers() {
    document.querySelectorAll('[data-bundle-timer]').forEach(el => {
      let total = parseInt(el.dataset.bundleTimer) || (Math.floor(Math.random()*8)+2)*3600+Math.floor(Math.random()*3600);
      const h = el.querySelector('.copa-bundle-timer-h');
      const m = el.querySelector('.copa-bundle-timer-m');
      const s = el.querySelector('.copa-bundle-timer-s');
      if (!h||!m||!s) return;
      const tick = () => { if(total<=0)return; total--; h.textContent=String(Math.floor(total/3600)).padStart(2,'0'); m.textContent=String(Math.floor((total%3600)/60)).padStart(2,'0'); s.textContent=String(total%60).padStart(2,'0'); };
      tick(); setInterval(tick,1000);
    });
  },
  initStockIndicators() {
    document.querySelectorAll('[data-stock]').forEach(el => {
      const stock = parseInt(el.dataset.stock);
      let cls='copa-stock--high',text='100+ in stock';
      if(stock<=5){cls='copa-stock--low';text=`🔥 Only ${stock} left!`;}
      else if(stock<=30){cls='copa-stock--medium';text=`${stock} left — selling fast`;}
      el.className=`copa-stock-indicator ${cls}`;
      el.innerHTML=`<span class="copa-stock-dot"></span>${text}`;
    });
  },
  initRipple() {
    document.addEventListener('click', e => {
      const btn = e.target.closest('.copa-btn-primary,.copa-add-btn,.copa-bundle-btn,.copa-modal-add');
      if(!btn) return;
      const rect = btn.getBoundingClientRect();
      const ripple = document.createElement('span');
      const size = Math.max(rect.width,rect.height)*2;
      ripple.style.cssText=`position:absolute;left:${e.clientX-rect.left-size/2}px;top:${e.clientY-rect.top-size/2}px;width:${size}px;height:${size}px;border-radius:50%;background:rgba(255,255,255,0.25);pointer-events:none;transform:scale(0);animation:ripple 0.6s linear forwards;`;
      if(getComputedStyle(btn).position==='static') btn.style.position='relative';
      btn.appendChild(ripple);
      setTimeout(()=>ripple.remove(),700);
    });
  },
  initEnhancedCart() {
    document.addEventListener('click', async e => {
      const btn = e.target.closest('.copa-add-btn[data-variant-id]');
      if(!btn) return;
      const varId=btn.dataset.variantId,name=btn.dataset.name||'Item',emoji=btn.dataset.emoji||'⚽';
      if(!varId) return;
      const origText=btn.textContent;
      btn.disabled=true;
      btn.textContent='Adding...';
      try {
        const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:varId,quantity:1})});
        if(res.ok){btn.textContent='✓ ADDED!';btn.classList.add('success');this.flyToCart(btn);const r=btn.getBoundingClientRect();this.confetti({x:r.left+r.width/2,y:r.top,count:35});this.toastV2(`${emoji} ${name}`,'Added to your cart!','cart');this._updateCartCount();}
        else{btn.textContent='Try again';this.toastV2('Could not add','Please try again','error');}
      }catch{btn.textContent='Error';}
      setTimeout(()=>{btn.textContent=origText;btn.disabled=false;btn.classList.remove('success');},2800);
    });
  },
  async _updateCartCount() {
    try{const cart=await(await fetch('/cart.js')).json();document.querySelectorAll('.copa-cart-count').forEach(el=>{el.textContent=cart.item_count;el.style.display=cart.item_count>0?'flex':'none';el.classList.add('bump');setTimeout(()=>el.classList.remove('bump'),500);});}catch{}
  },
  initEnhancedWishlist() {
    document.addEventListener('click', e => {
      const btn=e.target.closest('.copa-product-wish');
      if(!btn) return;
      const isActive=btn.classList.toggle('active');
      btn.textContent=isActive?'♥':'♡';
      if(isActive){const r=btn.getBoundingClientRect();this.confetti({x:r.left+r.width/2,y:r.top,count:20,colors:['#f43f5e','#fb7185','#fda4af','#fff']});this.toastV2('Saved to wishlist!','','wish');}
    });
  },
  initMegaMenu() {
    const categories=[{handle:'tournament-tees',name:'Tournament Tees',icon:'⚽',count:5},{handle:'head-to-toe-gear',name:'Head-to-Toe Gear',icon:'🧣',count:4},{handle:'stadium-spirit',name:'Stadium Spirit',icon:'🤙',count:4},{handle:'collectors-corner',name:"Collector's Corner",icon:'🏆',count:4}];
    document.querySelectorAll('.copa-nav a').forEach(link=>{
      const href=link.getAttribute('href')||'';
      const cat=categories.find(c=>href.includes(c.handle));
      if(!cat) return;
      const menu=document.createElement('div');
      menu.className='copa-mega-menu';
      menu.innerHTML=categories.map(c=>`<a href="/collections/${c.handle}" class="copa-mega-item"><span style="font-size:1.4rem;width:36px">${c.icon}</span><div><div style="font-size:0.85rem;font-weight:700;color:#e2e8f0">${c.name}</div><div style="font-size:0.72rem;color:#64748b">${c.count} products</div></div></a>`).join('');
      link.parentElement.style.position='relative';
      link.parentElement.appendChild(menu);
    });
  },
  typewrite(el,words,speed=120,pause=2200){
    if(!el) return;
    let wi=0,ci=0,deleting=false;
    const tick=()=>{
      const word=words[wi%words.length];
      el.textContent=deleting?word.slice(0,ci--):word.slice(0,ci++);
      let delay=deleting?speed/2:speed;
      if(!deleting&&ci===word.length+1){delay=pause;deleting=true;}
      if(deleting&&ci<0){deleting=false;ci=0;wi++;delay=400;}
      setTimeout(tick,delay);
    };
    tick();
  },
  initHeroTypewriter(){
    const el=document.getElementById('copa-typewriter');
    if(!el) return;
    this.typewrite(el,['OFFICIAL GEAR','FAN MERCHANDISE','STADIUM ESSENTIALS','COLLECTOR ITEMS','GAME DAY MUST-HAVES']);
  },
  _exitShown:false,
  initExitIntent(){
    if(sessionStorage.getItem('copa_exit_shown')) return;
    const popup=document.createElement('div');
    popup.className='copa-exit-popup';
    popup.id='copaExitPopup';
    popup.innerHTML=`<div class="copa-exit-box"><button style="position:absolute;top:1rem;right:1rem;background:none;border:none;color:#475569;font-size:1.2rem;cursor:pointer" id="exitClose">✕</button><span style="font-size:4rem;display:block;margin-bottom:1rem">⚽</span><h2 class="copa-exit-title">WAIT! BEFORE YOU GO...</h2><p style="color:#94a3b8;font-size:0.95rem;margin-bottom:1.5rem">Get <strong style="color:#fbbf24">15% OFF</strong> your first order!<br>Use code at checkout:</p><div class="copa-exit-code" id="exitCode" title="Click to copy">COPA15</div><button class="copa-btn-primary" style="width:100%;border:none;padding:1rem;cursor:pointer;font-size:1rem" onclick="document.getElementById('copaExitPopup').classList.remove('open')">🛒 SHOP WITH 15% OFF</button><button style="display:block;margin-top:1rem;font-size:0.78rem;color:#475569;cursor:pointer;background:none;border:none" id="exitDismiss">No thanks, I'll pay full price</button></div>`;
    document.body.appendChild(popup);
    const close=()=>{popup.classList.remove('open');sessionStorage.setItem('copa_exit_shown','1');};
    document.getElementById('exitClose').addEventListener('click',close);
    document.getElementById('exitDismiss').addEventListener('click',close);
    popup.addEventListener('click',e=>{if(e.target===popup)close();});
    document.getElementById('exitCode').addEventListener('click',()=>{navigator.clipboard?.writeText('COPA15');this.toastV2('Code copied!','COPA15 — 15% off your order','success');});
    document.addEventListener('mouseleave',e=>{if(e.clientY<20&&!this._exitShown&&!sessionStorage.getItem('copa_exit_shown')){this._exitShown=true;popup.classList.add('open');}});
    setTimeout(()=>{if(!this._exitShown&&!sessionStorage.getItem('copa_exit_shown')){this._exitShown=true;popup.classList.add('open');}},45000);
  },
  initNewsletterSuccess(){
    document.querySelectorAll('.copa-newsletter-form,#copa-newsletter-form').forEach(form=>{
      form.addEventListener('submit',async e=>{
        e.preventDefault();
        const wrap=form.closest('.copa-newsletter-inner')||form.parentElement;
        await new Promise(r=>setTimeout(r,600));
        const r=form.getBoundingClientRect();
        this.confetti({x:r.left+r.width/2,y:r.top+r.height/2,count:50});
        wrap.innerHTML=`<div style="text-align:center;padding:1.5rem"><div style="font-size:3rem">🎉</div><h3 style="font-family:'Bebas Neue',sans-serif;font-size:1.8rem;color:#fff;letter-spacing:2px;margin:0.5rem 0">YOU'RE IN!</h3><p style="color:#94a3b8;font-size:0.9rem">Check your inbox for your exclusive <strong style="color:#fbbf24">15% OFF</strong> code.</p></div>`;
        this.toastV2('Subscribed!','Check your inbox for your discount code','success');
      });
    });
  },
  initBundleHoverConfetti(){
    document.querySelectorAll('.copa-bundle-card.most-popular').forEach(card=>{
      let timer;
      card.addEventListener('mouseenter',()=>{const r=card.getBoundingClientRect();timer=setInterval(()=>{this.confetti({x:r.left+Math.random()*r.width,y:r.top+r.height/2,count:8});},600);});
      card.addEventListener('mouseleave',()=>clearInterval(timer));
    });
  },
  initLiveVisitors(){
    const el=document.getElementById('copa-live-count');
    if(!el) return;
    let count=Math.floor(Math.random()*40)+25;
    el.textContent=count;
    setInterval(()=>{count+=Math.floor(Math.random()*5)-2;count=Math.max(15,Math.min(count,80));el.textContent=count;},4000+Math.random()*3000);
  },
  enhanceFadeIns(){
    const obs=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('visible');obs.unobserve(e.target);}});},{threshold:0.08});
    document.querySelectorAll('.copa-fade').forEach(el=>obs.observe(el));
  },
  injectHeroBadges(){
    const hero=document.querySelector('.copa-hero-content');
    if(!hero||document.querySelector('.copa-float-badges')) return;
    const badges=document.createElement('div');
    badges.className='copa-float-badges';
    badges.innerHTML='<span class="copa-float-badge copa-float-badge--free">🚚 Free Shipping $50+</span><span class="copa-float-badge copa-float-badge--official">✅ Official Merchandise</span><span class="copa-float-badge copa-float-badge--limited">🔥 Limited Stock</span>';
    const eyebrow=hero.querySelector('.copa-hero-eyebrow');
    if(eyebrow) eyebrow.after(badges); else hero.prepend(badges);
  },
  injectHeroProof(){
    const ctas=document.querySelector('.copa-hero-ctas');
    if(!ctas||document.querySelector('.copa-hero-proof')) return;
    const proof=document.createElement('div');
    proof.className='copa-hero-proof';
    proof.innerHTML='<div class="copa-proof-avatars"><span class="copa-proof-avatar">🦅</span><span class="copa-proof-avatar">🍁</span><span class="copa-proof-avatar">🌵</span><span class="copa-proof-avatar">⚽</span></div><span>👥 <strong><span id="copa-live-count">47</span>+ fans</strong> shopping right now</span>';
    ctas.before(proof);
    this.initLiveVisitors();
  },
  injectStockIndicators(){
    document.querySelectorAll('.copa-product-card').forEach((card,i)=>{
      const info=card.querySelector('.copa-product-info');
      if(!info||card.querySelector('.copa-stock-indicator')) return;
      const stocks=[120,8,3,45,92,5,67,12];
      const s=stocks[i%stocks.length];
      const indicator=document.createElement('div');
      indicator.dataset.stock=s;
      info.insertBefore(indicator,info.querySelector('.copa-product-price-row'));
    });
    this.initStockIndicators();
  },
  injectQuickViewButtons(){
    document.querySelectorAll('.copa-product-card').forEach(card=>{
      const imgWrap=card.querySelector('.copa-product-img-wrap');
      if(!imgWrap||imgWrap.querySelector('.copa-quick-view-btn')) return;
      const btn=document.createElement('button');
      btn.className='copa-quick-view-btn';
      btn.textContent='⚡ QUICK VIEW';
      const name=card.querySelector('.copa-product-name')?.textContent.trim()||'';
      const price=card.querySelector('.copa-product-price')?.textContent.trim()||'';
      const emoji=card.querySelector('.copa-product-emoji')?.textContent.trim()||'⚽';
      btn.dataset.quickView=JSON.stringify({title:name,price,emoji});
      imgWrap.appendChild(btn);
    });
  },
  injectFooterTrust(){
    const footerBrand=document.querySelector('.copa-footer-brand');
    if(!footerBrand||footerBrand.querySelector('.copa-trust-row')) return;
    const row=document.createElement('div');
    row.className='copa-trust-row';
    row.style.cssText='display:flex;gap:0.75rem;flex-wrap:wrap;margin-top:1rem;';
    row.innerHTML='<span class="copa-trust-badge">🔒 SSL Secure</span><span class="copa-trust-badge">↩️ 30-day returns</span><span class="copa-trust-badge">🏅 Authentic</span>';
    const social=document.createElement('div');
    social.style.cssText='display:flex;gap:0.75rem;margin-top:1rem;';
    social.innerHTML='<a href="#" style="width:36px;height:36px;border-radius:0.5rem;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.08);display:flex;align-items:center;justify-content:center;font-size:1rem;text-decoration:none;transition:all 0.3s">📘</a><a href="#" style="width:36px;height:36px;border-radius:0.5rem;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.08);display:flex;align-items:center;justify-content:center;font-size:1rem;text-decoration:none;transition:all 0.3s">📸</a><a href="#" style="width:36px;height:36px;border-radius:0.5rem;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.08);display:flex;align-items:center;justify-content:center;font-size:1rem;text-decoration:none;transition:all 0.3s">🎵</a>';
    footerBrand.appendChild(row);
    footerBrand.appendChild(social);
  },
  injectNewsletterBenefits(){
    const inner=document.querySelector('.copa-newsletter-inner');
    if(!inner||inner.querySelector('.copa-newsletter-benefits')) return;
    const benefits=document.createElement('div');
    benefits.style.cssText='display:flex;gap:1.5rem;justify-content:center;flex-wrap:wrap;margin-bottom:1.5rem;';
    benefits.innerHTML='<div style="display:flex;align-items:center;gap:0.5rem;font-size:0.8rem;color:#94a3b8"><span style="font-size:1.1rem">🎁</span><span>15% off first order</span></div><div style="display:flex;align-items:center;gap:0.5rem;font-size:0.8rem;color:#94a3b8"><span style="font-size:1.1rem">🚀</span><span>Early access drops</span></div><div style="display:flex;align-items:center;gap:0.5rem;font-size:0.8rem;color:#94a3b8"><span style="font-size:1.1rem">📦</span><span>Free shipping codes</span></div>';
    const form=inner.querySelector('form,.copa-newsletter-form');
    if(form) form.before(benefits);
    const proof=document.createElement('p');
    proof.style.cssText='font-size:0.75rem;color:#64748b;margin-top:0.75rem;';
    proof.innerHTML='Join <strong style="color:#00d4ff">50,000+</strong> World Cup fans &nbsp;·&nbsp; No spam, ever.';
    if(form) form.after(proof);
  },
  init(){
    this.initProgressBar();
    this.initBackToTop();
    this.initBottomNav();
    this.initToastsV2();
    this.initRipple();
    this.initQuickView();
    this.initParallax();
    this.initBundleTimers();
    this.initEnhancedCart();
    this.initEnhancedWishlist();
    this.initMegaMenu();
    this.initHeroTypewriter();
    this.initNewsletterSuccess();
    this.initBundleHoverConfetti();
    this.initLazyImages();
    this.enhanceFadeIns();
    this.injectHeroBadges();
    this.injectHeroProof();
    this.injectStockIndicators();
    this.injectQuickViewButtons();
    this.injectFooterTrust();
    this.injectNewsletterBenefits();
    setTimeout(()=>this.initExitIntent(),3000);
  }
};
document.addEventListener('DOMContentLoaded',()=>COPA_ENHANCED.init());